import * as React from 'react';
import { useSelector } from 'react-redux';

import { ToastMessages } from '../../State';
import ToastMessage from './ToastMessage';

import styles from './toast-message-wrapper.module.css';

function ToastMessageWrapper(): React.ReactElement {
    const messages: ToastMessages.Types.ToastMessage[] = useSelector(ToastMessages.selectors.toastMessages);

    return (
        <div className={styles.ToastMessageWrapper}>
            {messages.map((toastMessage: ToastMessages.Types.ToastMessage) => (
                <ToastMessage key={`toast-message-${toastMessage.id}`} toastMessage={toastMessage} />
            ))}
        </div>
    );
}

export default ToastMessageWrapper;
